import React from 'react'
import { useTranslation } from 'react-i18next'
import { FormikProps } from 'formik'

import FieldComponent from '../../../../../../../components/Form/Field'
import FieldLabelWrapperComponent from '../../../../../../../features/components/Form/FieldLabelWrapper'
import ErrorMessage from '../../../../../../../components/Form/ErrorMessage'
import MissingDataWarnings from '../../../../../../Facebook/UploadFacebookAdCreative/UploadFacebookAdCreativeForm/CampaignForm/NewCampaignFields/MissingDataWarnings'

import {
  useFormattedObjectivesList,
  useObjectivesListIsLoading
} from '../../../../../../Facebook/UploadFacebookAdCreative/UploadFacebookAdCreativeForm/CampaignForm/NewCampaignFields/hooks'

import { OBJECTIVE } from '../../../../../CampaignForms/fields'

import useDrawerFormStyles from '../../../../../../../styles/common/drawerForms'

interface GoalBudgetFieldsProps {
  formik: FormikProps<any>
  remainingBudget: number
}

// Type-safe aliases to avoid TypeScript errors with JS components
const Field = FieldComponent as any
const FieldLabelWrapper = FieldLabelWrapperComponent as any

const GoalBudgetFields: React.FC<GoalBudgetFieldsProps> = ({ formik, remainingBudget }) => {
  const drawerFormClasses = useDrawerFormStyles()
  const { t } = useTranslation()

  const { values } = formik

  const formattedObjectivesList = useFormattedObjectivesList()
  const isObjectivesListLoading = useObjectivesListIsLoading()

  if (remainingBudget < 1) {
    return <ErrorMessage fontSize={12} error="Your total remaining budget is too low to create a campaign." />
  }

  return (
    <div className={drawerFormClasses.subSection}>
      <FieldLabelWrapper label={t('Campaign goal')} horizontalView={true}>
        <Field
          name={OBJECTIVE}
          label="Goal"
          placeholder="Select goal..."
          formik={formik}
          options={formattedObjectivesList}
          isLoading={isObjectivesListLoading}
        />
        <MissingDataWarnings values={values} />
      </FieldLabelWrapper>
    </div>
  )
}

export default GoalBudgetFields
